"use strict";

require("core-js/modules/es6.string.small");

var _defineProperty = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var button_1 = tslib_1.__importDefault(require("@patternfly/react-styles/css/components/Button/button"));

var react_styles_1 = require("@patternfly/react-styles");

var helpers_1 = require("../../helpers");

var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant["primary"] = "primary";
  ButtonVariant["secondary"] = "secondary";
  ButtonVariant["tertiary"] = "tertiary";
  ButtonVariant["danger"] = "danger";
  ButtonVariant["link"] = "link";
  ButtonVariant["plain"] = "plain";
  ButtonVariant["control"] = "control";
})(ButtonVariant = exports.ButtonVariant || (exports.ButtonVariant = {}));

var ButtonType;

(function (ButtonType) {
  ButtonType["button"] = "button";
  ButtonType["submit"] = "submit";
  ButtonType["reset"] = "reset";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));

exports.Button = function (_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'button' : _a$component,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$isBlock = _a.isBlock,
      isBlock = _a$isBlock === void 0 ? false : _a$isBlock,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isAriaDisabled = _a.isAriaDisabled,
      isAriaDisabled = _a$isAriaDisabled === void 0 ? false : _a$isAriaDisabled,
      _a$isSmall = _a.isSmall,
      isSmall = _a$isSmall === void 0 ? false : _a$isSmall,
      _a$inoperableEvents = _a.inoperableEvents,
      inoperableEvents = _a$inoperableEvents === void 0 ? ['onClick', 'onKeyPress'] : _a$inoperableEvents,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      _a$type = _a.type,
      type = _a$type === void 0 ? ButtonType.button : _a$type,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? ButtonVariant.primary : _a$variant,
      _a$iconPosition = _a.iconPosition,
      iconPosition = _a$iconPosition === void 0 ? 'left' : _a$iconPosition,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? null : _a$ariaLabel,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      ouiaId = _a.ouiaId,
      _a$ouiaSafe = _a.ouiaSafe,
      ouiaSafe = _a$ouiaSafe === void 0 ? true : _a$ouiaSafe,
      _a$tabIndex = _a.tabIndex,
      tabIndex = _a$tabIndex === void 0 ? null : _a$tabIndex,
      props = tslib_1.__rest(_a, ["children", "className", "component", "isActive", "isBlock", "isDisabled", "isAriaDisabled", "isSmall", "inoperableEvents", "isInline", "type", "variant", "iconPosition", 'aria-label', "icon", "ouiaId", "ouiaSafe", "tabIndex"]);

  var Component = component;
  var isButtonElement = Component === 'button';

  if (isAriaDisabled && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('You are using a beta component feature (isAriaDisabled). These api parts are subject to change in the future.');
  }

  var preventedEvents = inoperableEvents.reduce(function (handlers, eventToPrevent) {
    return Object.assign(Object.assign({}, handlers), _defineProperty({}, eventToPrevent, function (event) {
      event.preventDefault();
    }));
  }, {});

  var getDefaultTabIdx = function getDefaultTabIdx() {
    if (isDisabled) {
      return isButtonElement ? null : -1;
    } else if (isAriaDisabled) {
      return null;
    }
  };

  return React.createElement(Component, Object.assign({}, props, isAriaDisabled ? preventedEvents : null, {
    "aria-disabled": isDisabled || isAriaDisabled,
    "aria-label": ariaLabel,
    className: react_styles_1.css(button_1["default"].button, button_1["default"].modifiers[variant], isBlock && button_1["default"].modifiers.block, isDisabled && button_1["default"].modifiers.disabled, isAriaDisabled && button_1["default"].modifiers.ariaDisabled, isActive && button_1["default"].modifiers.active, isInline && variant === ButtonVariant.link && button_1["default"].modifiers.inline, isSmall && button_1["default"].modifiers.small, className),
    disabled: isButtonElement ? isDisabled : null,
    tabIndex: tabIndex !== null ? tabIndex : getDefaultTabIdx(),
    type: isButtonElement ? type : null
  }, helpers_1.getOUIAProps(exports.Button.displayName, ouiaId, ouiaSafe)), variant !== ButtonVariant.plain && icon && iconPosition === 'left' && React.createElement("span", {
    className: react_styles_1.css(button_1["default"].buttonIcon, button_1["default"].modifiers.start)
  }, icon), children, variant !== ButtonVariant.plain && icon && iconPosition === 'right' && React.createElement("span", {
    className: react_styles_1.css(button_1["default"].buttonIcon, button_1["default"].modifiers.end)
  }, icon));
};

exports.Button.displayName = 'Button';